<template>
    <div class="personal-center">
        <div class="logo" @click="goHome">
            <img src="@/assets/images/common/bLogo.png" alt="">
        </div>
        <div class="header">
            <div class="profile-avatar">
                <img :src="hederImg"
                    alt="User Avatar">
            </div>
            <div class="profile-info">
                <h2>{{ user.name }}</h2>
                <p>{{ user.company }}</p>
            </div>
            <button class="edit-profile"  @click="editPage">
                <img class="proImg" src="@/assets/images/Edit.png" alt="Edit Icon"> <p class="txt"> 编辑个人资料</p>
            </button>
        </div>

        <div class="content-panel">
            <div class="left-panel">
                <div class="info-item">
                    <span class="label">联系电话</span>
                    <span class="value">{{ user.phone_data }}</span>
                </div>
                <div class="info-item">
                    <span class="label">公司</span>
                    <span class="value">{{ user.company }}</span>
                </div>
                <div class="info-item">
                    <span class="label">职务</span>
                    <span class="value">{{ user.job_title }}</span>
                </div>
                <div class="info-item">
                    <span class="label">所在地区</span>
                    <span class="value">{{ user.region }}</span>
                </div>
                <div class="info-item">
                    <span class="label">所在行业</span>
                    <span class="value">{{ user.industry }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            backgroundImage: 'background-image-url.jpg',
            hederImg:null,
            user: {
            
            }
        };
    },
    mounted(){
        this.initShare();
        this.userData();
        this.hederImg = this.$localStorage.getItem("headimgurl") || '';
        this.$dataStatistics({
            page_title: `个人中心`,
        },'访问');

    },
    methods: {
        editPage() {
            console.log("123123");
            this.$router.push('/EditRegister')
        },
        goHome(){
      this.$router.push('/')
    },
        userData() {
            this.checkUser().then(res => {
                if (!res.errcode) {
                    this.user = res;
                }
            })
        },
        checkUser() {
            return new Promise((resolve) => {
                let openid = this.$localStorage.getItem("openid");
                let params = { openid }
                this.$http.get("/api/platform/member/get-user-info", { params }).then((res) => {
                    resolve(res.data);
                })
            });
        },

    }
};
</script>
  
<style scoped lang="less">
.personal-center {
    width: 100%;
    max-width: 800px;
    min-height: 100vh;
    margin: 0 auto;
    padding: 18px 12px;
    background: #FAFAFA;
}

.logo {
    width: 142px;
    height: 20px;
    margin-bottom: 67px;
    img{
        width: 100%;
        height: 100%;
    }
}

.header {
    position: relative;
    background: url('~@/assets/images/userBg.png') no-repeat center / 100% 100%;
    width: 351px;
    height: 108px;
    margin-bottom: 12px;
    border-radius: 8px;
}

.profile-avatar {
    position: absolute;
    top: -40px;
    left: 24px;
    width: 80px;
    height: 80px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    overflow: hidden;

}

.profile-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile-info {
    position: absolute;
    left: 24px;
    top: 48px;

}

.profile-info p {
    font-size: 12px;
    color: #FFFFFF;
    line-height: 18px;
    margin-top: 2px;

}

.profile-info h2 {
    font-size: 16px;
    color: #FFFFFF;
    line-height: 24px;
}

.edit-profile {
    position: absolute;
    right: 10px;
    top: 10px;
    border: none;
    width: 92px;
    height: 23px;
    border-radius: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.1);
    .txt{
        // line-height: 15px;
    }
    .proImg {
        position: relative;
        top: -1px;
        margin-right: 2px;
        width: 12px;
        height: 12px;
    }

}

.content-panel {
    display: flex;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 16px 16px 4px 16px;
    width: 100%;
}

.left-panel {
    flex: 1;
}

.info-item {
    margin-bottom: 16px;
    color: #5D5D61;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
}

.label {
    word-break: keep-all;
}

.value {
    text-align: right;
    color: #333333;
}
</style>